export enum LoaderColorEnum {
    WHITE = 'white',
    BLACK = 'black',
    PINK = 'pink',
    GREEN = 'green',
    PURPLE = 'purple',
    Dark_GREEN = 'dark_green'
  }